import styled, { css } from 'styled-components';
import { breakpoint } from '@sketch/global-styles';
import { Grid, NavigationSelector } from '@sketch/components';
import '../GenericSectionTitle/index.js';
import GenericSectionTitle from '../GenericSectionTitle/GenericSectionTitle.js';

const StyledGrid = styled(Grid) `
  ${({ $stretch }) => $stretch ? `align-content: stretch;` : `align-content: flex-start;`}
`;
const Container = styled.section `
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const ItemsContainer = styled.div `
  display: flex;
  flex: 1 0 auto;
`;
const Separator = styled.hr `
  margin-bottom: 40px; /* stylelint-disable-line scales/space */
  border-color: ${({ theme }) => theme.colors.border.A};

  /* Makes the divider full width in mobile */
  ${breakpoint('base', 'xs') `
    margin-left: -16px;
    margin-right: -16px;
  `}

  ${breakpoint('sm') `
    margin-bottom: 28px;
  `}

  ${breakpoint('md') `
    margin-bottom: 28px;
  `}

  ${breakpoint('lg') `
    margin-bottom: 44px;
  `}

  ${breakpoint('xl') `
    margin-bottom: 14px;
  `}
`;
const StyledNavigationSelector = styled(NavigationSelector) `
  margin-right: 0;
  align-self: flex-end;
`;
const GenericTitle = styled(GenericSectionTitle) `
  margin-bottom: 20px;

  box-shadow: 0 0 0 0 transparent;
  transition: box-shadow ${({ theme }) => theme.transitions.duration[3]};

  ${({ theme, $isSticky }) => breakpoint('base', 'xs') `
    position: sticky;
    top: ${theme.header.height + 1}px;
    margin-left: -16px;
    margin-right: -16px;
    padding: 16px;
    background: ${theme.colors.background.secondary.A};
    z-index: ${theme.zIndex[2]};

    ${$isSticky &&
    css `
        box-shadow: 0 1px 0 0 ${theme.colors.border.B};
      `}
  `};
`;

export { Container, GenericTitle, ItemsContainer, Separator, StyledGrid, StyledNavigationSelector };
